import React from 'react';
import { Image } from 'antd';
import './style.scss';
import NoImage from '../../../assets/images/no-image.png';

const MyImage = ({
  src = '',
  width = 'auto',
  height,
  fallback = '',
  preview = false,
  className = '',
  ...rest
}) => (
  <Image
    width={width}
    height={height}
    src={src}
    fallback={fallback || NoImage}
    preview={preview}
    {...rest}
    className={`my-image ${className}`}
  />
);

export default MyImage;
